export default function isPickingCardByInstance(state, instanceId) {
  const instanceState = state.games.taboo.instances.find(({ entity }) => entity.id === instanceId);
  return !!instanceState?.isPickingCard;
}
